import { Theme } from '@emotion/react';
import { color } from '../Styles';

export type TinyVariant =
    | 'primary'
    | 'secondary'
    | 'accent'
    | 'accent_2'
    | 'error'
    | 'success'
    | 'diminished'
    | 'diminished_accent'
    | 'diminished_error'
    | 'diminished_success'
    | 'text'
    | 'underline_text'
    | 'underline_diminished';

export const getTinyVariantColor = (variant: TinyVariant, theme: Theme) => {
    if (variant === 'primary') return color.primary;
    if (variant === 'secondary') return color.secondary;
    if (variant === 'accent') return color.primary_light;
    if (variant === 'accent_2') return color.accent_2_dark_text;
    if (variant === 'success') return color.success_dark;
    if (variant === 'error') return color.error_dark;
    if (variant === 'diminished') return theme.color.textBody;
    if (variant === 'diminished_accent') return theme.color.textBodyLight;
    if (variant === 'diminished_error') return theme.color.error;
    if (variant === 'diminished_success') return theme.color.success;
    if (variant === 'text' || variant === 'underline_text') return theme.color.text;
    if (variant === 'underline_diminished') return theme.color.textBody;
};

export const getTinyVariantBackground = (variant: TinyVariant, theme: Theme) => {
    if (variant === 'primary') return color.primary_card_border;
    if (variant === 'secondary') return color.secondary_card_border;
    if (variant === 'accent') return color.accent_light;
    if (variant === 'accent_2') return color.accent_2_light;
    if (variant === 'success') return color.success_card_border;
    if (variant === 'error') return color.error_card_border;
    if (variant === 'diminished') return 'transparent';
    if (variant === 'diminished_accent') return 'transparent';
    if (variant === 'diminished_error') return 'transparent';
    if (variant === 'diminished_success') return 'transparent';
    if (variant === 'text' || variant === 'underline_text') return 'transparent';
    if (variant === 'underline_diminished') return 'transparent';
};

/**
 * The hover/focus fill for the interactive tiny rows: the resting text color becomes the background, so a
 * filled variant inverts into its own two colors.
 */
export const getTinyVariantHoverBackground = (variant: TinyVariant, theme: Theme) => {
    if (variant === 'diminished' || variant === 'underline_diminished') return theme.color.background;
    if (variant === 'text' || variant === 'underline_text') return theme.color.text;
    return getTinyVariantColor(variant, theme) || theme.color.text;
};

/**
 * The other half of that inversion. The diminished variants have no fill to swap in, so their hovered text
 * takes the surface behind them instead: the themed background for the themed variants, and the fixed light
 * surface for 'diminished_error' and 'diminished_success', whose hover fills are a saturated red or green in
 * either theme.
 */
export const getTinyVariantHoverColor = (variant: TinyVariant, theme: Theme) => {
    const background = getTinyVariantBackground(variant, theme);
    if (background && background !== 'transparent') return background;
    if (variant === 'diminished_accent') return theme.color.background;
    if (variant === 'text' || variant === 'underline_text') return theme.color.background;
    return variant === 'diminished_error' || variant === 'diminished_success' ? color.bg_light : theme.color.text;
};
